// `labelKey` instead of a literal label: the chip copy is resolved at render so
// it follows a language change (see src/i18n/README.md).
export const CHARGE_STATUSES = [
    { id: 'paid', labelKey: 'insights.chargeStatuses.paid', variant: 'success' },
    { id: 'pending', labelKey: 'insights.chargeStatuses.pending', variant: 'warning' },
    { id: 'refunded', labelKey: 'insights.chargeStatuses.refunded', variant: 'info' },
    { id: 'chargeback', labelKey: 'insights.chargeStatuses.chargeback', variant: 'danger' },
    { id: 'failed', labelKey: 'insights.chargeStatuses.failed', variant: 'danger' },
    { id: 'canceled', labelKey: 'insights.chargeStatuses.canceled', variant: 'default' },
];

export const CHARGE_STATUS_MAP = CHARGE_STATUSES.reduce((acc, s) => {
    acc[s.id] = s;
    return acc;
}, {});
